import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qyzzm2tfv: FaireProductEntity = {
  token: "p_4qyzzm2tfv",
  type: "product",
  name: "Farmhouse Small Soy Candles",
  brandName: "Sweet Grass Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/72e533b3f6c30e0135561af3ade81b244f51b3b26ebaba086435e5b4699bdb20.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/19cb431bdcd5d5169fe4cbf8e6e83121cd9880c32167c0e60ffd4e7fcffc1f60.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
